// [What] reCAPTCHA v3 tokens expire in ~2 minutes
// refresh immediately before submit to avoid posting an expired token and failing server verification

// [How] executeRecaptcha is the recaptcha gem global executeRecaptchaFor{Action}Async (data-recaptcha-execute-function)
// https://github.com/ambethia/recaptcha/blob/v5.16.0/README.md#recaptcha_v3
// write the token to hidden g-recaptcha-response, then form.submit()
const RECAPTCHA_TOKEN_REFRESH_FAILED_ALERT =
  'reCAPTCHA認証の準備に失敗しました。お手数ですが時間をおいて再度お試しください。';

function bindRecaptchaOnSubmit(form) {
  const { recaptchaExecuteFunction, recaptchaInputId } = form.dataset;
  if (!recaptchaExecuteFunction || !recaptchaInputId) return;

  const tokenElement = document.getElementById(recaptchaInputId);
  if (!tokenElement) return;

  form.addEventListener('submit', async (event) => {
    const executeRecaptcha = window[recaptchaExecuteFunction];
    if (typeof executeRecaptcha !== 'function') return;

    event.preventDefault();

    const token = await executeRecaptcha().catch(() => window.alert(RECAPTCHA_TOKEN_REFRESH_FAILED_ALERT));
    if (!token) return;

    tokenElement.value = token;
    form.submit();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const recaptchaForms = document.querySelectorAll('form[data-recaptcha-execute-function][data-recaptcha-input-id]');
  recaptchaForms.forEach(bindRecaptchaOnSubmit);
});
